const GA_MEASUREMENT_ID = "G-5P7C15SGBS";
export const ANALYTICS_CONSENT_KEY = "cookie-consent";

declare global {
  interface Window {
    dataLayer?: unknown[][];
    gtag?: (...args: unknown[]) => void;
  }
}

function hasAnalyticsConsent() {
  return typeof window !== "undefined"
    && window.localStorage.getItem(ANALYTICS_CONSENT_KEY) === "granted";
}

export function initialiseAnalytics() {
  if (!hasAnalyticsConsent() || document.querySelector(`script[data-ga-id="${GA_MEASUREMENT_ID}"]`)) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => {
    window.dataLayer?.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.dataset.gaId = GA_MEASUREMENT_ID;
  document.head.appendChild(script);
}

export function setAnalyticsConsent(consent: "granted" | "denied") {
  window.localStorage.setItem(ANALYTICS_CONSENT_KEY, consent);
  if (consent === "granted") {
    initialiseAnalytics();
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  if (!hasAnalyticsConsent()) {
    return;
  }

  initialiseAnalytics();
  window.gtag?.("event", eventName, params);
}
